export default __webpack_public_path__ + "static/media/chevron-black.b7409008.svg";